import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
// import { ToastContainer, toast } from 'react-toastify';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ShubhamImage from "../../../assest/images/reportlogo1.png";
import config from "../../../envconfig";
import { UserContext } from "../../common/UserContext";
import Icon8 from "../../../assest/images/Icon8.png";
import CustomDropdown from "../../common/CustomDropdown";


const ShipOutScanedList = () => {
  const {
    UM_GroupId,
    UM_CompanyGrpID,
    selectedScpId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    UM_DefaultSCPId,
  } = useContext(UserContext);
  const [selectedShipmentsBySCP, setSelectedShipmentsBySCP] = useState([]);
  const [userData, setUserdata] = useState([]);
  useEffect(() => {
    sessionStorage.setItem("UM_GroupId", UM_GroupId);
    sessionStorage.setItem("UM_CompanyGrpID", UM_CompanyGrpID);
    sessionStorage.setItem("UM_DefaultSCPId", UM_DefaultSCPId);
    sessionStorage.setItem("UM_CompanyID", UM_CompanyID);
    sessionStorage.setItem("UM_UserId", UM_UserId);
    sessionStorage.setItem("UM_UserCode", UM_UserCode);
    sessionStorage.setItem("selectedScpId", selectedScpId);
  }, [
    UM_GroupId,
    UM_CompanyGrpID,
    UM_DefaultSCPId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    selectedScpId,
  ]);
  // ========================== Log File ===============================
  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "Shipment Outward Scanning By Vendor :",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };
  //====================================================================

  useEffect(() => {
    const fetchSHIPUserData = async () => {
      try {
        const reqData = await fetch(
          `${config.API_URL}/Shipment_Completed_Scanned/${UM_CompanyGrpID}/${UM_CompanyID}/${selectedScpId}`,
          {
            method: "GET",
          }
        );
        if (reqData.ok) {
          const resData = await reqData.json();
          console.log("API Response:", resData); // Debugging log
          setUserdata(Array.isArray(resData.shipment) ? resData.shipment : []); // Ensure valid array
          logAction("Completed shipment fetched successfully");
        } else {
          setUserdata([]);
          console.error("Error fetching the shipment list");
        }
      } catch (error) {
        setUserdata([]);
        console.error("Failed to fetch data:", error);
      }
    };
    fetchSHIPUserData();
  }, [UM_CompanyGrpID, UM_CompanyID, selectedScpId]);

  const handlePrintPDF = async (shipmentCode) => {
    try {
      const response = await fetch(
        `${config.API_URL}/deliverychallan/${shipmentCode}/${selectedScpId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      console.log("API Response:", data); // Check the API response
      if (!data.success || !data.data || data.data.length === 0) {
        console.error("Data is empty or not fetched correctly:", data);
        return;
      }
      data.data.forEach(({ scpto, toscp, shipmentDetails, productDetails }) => {
        const doc = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });

        // PDF generation code for individual scpto
        const textColor = [0, 0, 0]; // Black (RGB)
        const headerTextColor = [255, 255, 255]; // White (RGB)
        const headerColor = [135, 206, 250]; // Light Blue (RGB)
        const rowColor = [255, 255, 255]; // White (RGB)

        const styles = {
          title: {
            fontSize: 24,
            color: textColor,
            fontStyle: "bold",
            margin: { top: 20 },
            align: "center",
          },
          detailsTable: {
            fontSize: 12,
            color: textColor,
            margin: { top: 10 },
            fillColor: rowColor,
          },
          tableHeader: {
            fontSize: 12,
            color: headerTextColor,
            fontStyle: "bold",
            fillColor: headerColor,
          },
          tableRow: {
            fontSize: 10,
            color: textColor,
            fillColor: rowColor,
          },
        };

        if (shipmentDetails.length > 0) {
          const imgData = ShubhamImage;
          doc.addImage(imgData, "PNG", 10, 10, 40, 20);

         
          const date = new Date();
          const formattedDate = `${String(date.getDate()).padStart(2,"0")}/${String(date.getMonth() + 1).padStart(2,"0")}/${date.getFullYear()}`;
          const printedBy = `Printed By : ${UM_UserCode}`;
          const printedOn = `Printed On : ${formattedDate}`;
        const startX = doc.internal.pageSize.getWidth() - 50;
        const startY = 20;
        const baseX = startX;
        const y1 = startY + 5;
        const y2 = startY;

        const colonOffset = 14.5;  // distance from label to colon
        const valueOffset = 16.5;  // distance from label to value (a few px after colon)

        doc.setFontSize(8);

        // 📝 Printed On
        doc.text("Printed On", baseX, y2, { align: "left" });
        doc.text(":", baseX + colonOffset, y2);
        doc.text(formattedDate, baseX + valueOffset, y2);

        // 📝 Printed By
        doc.text("Printed By", baseX, y1, { align: "left" });
        doc.text(":", baseX + colonOffset, y1);
        doc.text(UM_UserCode, baseX + valueOffset, y1);
          const columnWidth = (doc.internal.pageSize.width - 30) / 2; // Divide by 2 for two equal columns

          const FromlocationTable = [
            [
              {
                content: "Delivered By",
                colSpan: 2,
                styles: {
                  halign: "center",
                  fontSize: 12,
                  fillColor: [41, 128, 185],
                  textColor: [255, 255, 255],
                },
              },
            ],
            [
              "Address",
              `${shipmentDetails[0].Street1}, ${shipmentDetails[0].Street2}`,
            ],
            ["City", shipmentDetails[0].City],
            ["State", shipmentDetails[0].State],
            ["Country", shipmentDetails[0].Country],
            ["Email Address", shipmentDetails[0].Email],
            ["Contact No.", shipmentDetails[0].CNo],
          ];

          doc.autoTable({
            head: [],
            body: FromlocationTable,
            startY: 50,
            theme: "grid",
            styles: {
              ...styles.detailsTable,
              cellPadding: 2,
              valign: "middle",
              halign: "center",
              fontSize: 10,
            },
            columnStyles: {
              0: { cellWidth: columnWidth }, //cell padding to decrease the size between the two rows
              1: { cellWidth: columnWidth },
            },
          });

          const locationTable = [
            [
              {
                content: "Shipping To",
                colSpan: 2,
                styles: {
                  halign: "center",
                  fontSize: 12,
                  fillColor: [41, 128, 185],
                  textColor: [255, 255, 255],
                },
              },
            ],
            [
              "Address",
              `${shipmentDetails[0].LCM_LocationStreet1}, ${shipmentDetails[0].LCM_LocationStreet2}`,
            ],
            ["City", shipmentDetails[0].LCM_City],
            ["State", shipmentDetails[0].LCM_State],
            ["Country", shipmentDetails[0].LCM_Country],
            ["Email Address", shipmentDetails[0].LCM_EmailID],
            ["Contact No.", shipmentDetails[0].LCM_ContactNumber],
          ];

          doc.autoTable({
            head: [],
            body: locationTable,
            startY: doc.autoTable.previous.finalY + 5,
            theme: "grid",
            styles: {
              ...styles.detailsTable,
              cellPadding: 2,
              valign: "middle",
              halign: "center",
              fontSize: 10,
            },
            columnStyles: {
              0: { cellWidth: columnWidth }, //cell padding to decrease the size between the two rows
              1: { cellWidth: columnWidth },
            },
          });

          const detailsTable = [
            [
              {
                content: "Shipment Information",
                colSpan: 2,
                styles: {
                  halign: "center",
                  fontSize: 12,
                  fillColor: [41, 128, 185],
                  textColor: [255, 255, 255],
                },
              },
            ],
            ["Delivery No", shipmentDetails[0].dcl_DeliveryNo],
            ["From Party", shipmentDetails[0].FromParty],
            ["To Party", shipmentDetails[0].ToParty],
            ["Logistic Party Name", shipmentDetails[0].LGCM_Name],
            ["Vehicle Number", shipmentDetails[0].LGCVM_VehicleNumber],
          ];

          doc.autoTable({
            head: [],
            body: detailsTable,
            startY: doc.autoTable.previous.finalY + 5,
            theme: "grid",
            styles: {
              ...styles.detailsTable,
              cellPadding: 2,
              valign: "middle",
              halign: "center",
              fontSize: 10,
            },
            columnStyles: {
              0: { cellWidth: columnWidth }, //cell padding to decrease the size between the two rows
              1: { cellWidth: columnWidth },
            },
          });

          const batchDataHeaderText = "Product Details";
          const headers = [
            "Sr. No.",
            "Product Code",
            "Product Name",
            "Quantity",
          ];

          let tableData = [];

          // Add the "Batch Data" row with colSpan
          tableData.push([
            {
              content: batchDataHeaderText,
              colSpan: 4,
              styles: {
                halign: "center",
                fontSize: 12,
                textColor: [255, 255, 255],
                fillColor: [41, 128, 185],
              },
            },
          ]);

          // Add the header row with styles
          tableData.push(
            headers.map((header) => ({
              content: header,
              styles: {
                halign: "center",
                fillColor: [41, 128, 185],
                textColor: [255, 255, 255],
              },
            }))
          );

          // Add the product details rows
          tableData = tableData.concat(
            productDetails.map((row, index) => [
              { content: index + 1, styles: { halign: "center" } },
              row.dcm_productCode,
              row.dcm_productname,
              row.dcm_qty,
            ])
          );

          doc.addPage();

          doc.autoTable({
            body: tableData,
            startY: 10,
            theme: "grid",
            headStyles: {
              fillColor: [41, 128, 185],
              textColor: [255, 255, 255],
              lineWidth: 0.25,
              cellPadding: 2,
              valign: "middle",
              halign: "center",
              fontSize: 10,
              rowHeight: 8,
              border: {
                top: { style: "solid", width: 0.25, color: [0, 0, 0] },
              },
            },
            styles: {
              cellPadding: 2,
              valign: "middle",
              halign: "center",
            },
          });

          const signatureContent = [
            ["", "            ", "      ", "__________________________"],
            ["", "            ", "      ", "      Authorised Signature   "],
          ];

          // Calculate startX to align to the right side

          doc.autoTable({
            startY: doc.autoTable.previous.finalY + 5,
            body: signatureContent,
            theme: "plain",
            columnStyles: {
              0: { cellWidth: 40 },
              1: { cellWidth: 40 },
              2: { cellWidth: 40 },
            },
            styles: { fontSize: 11 },
            headStyles: { fontWeight: "normal" }, // Remove bold from head

            startX: startX,
          });

          const previousTableFinalY = doc.autoTable.previous.finalY;
          const lineStartY = previousTableFinalY + 5;
          const lineEndY = lineStartY + 2;

          // Draw a blue dark line
          doc.setDrawColor(135, 206, 250); // Light blue color (RGB)
          doc.setLineWidth(0.5);
          doc.line(10, lineStartY, 200, lineStartY);

          const tableContent = [
            [
              { content: "Recieved By", styles: { fontStyle: "bold" } },
              "            ",
              { content: "Delivered By", styles: { fontStyle: "bold" } },
              "",
            ],
            ["Name", ":            ", "Name", ":"],
            ["Date", ":            ", "Date", ":"],
            ["Signature", ":            ", "Signature", ":"],
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY + 5,

            body: tableContent,
            theme: "plain",
            columnStyles: {
              0: { cellWidth: 40 },
              1: { cellWidth: 60 },
              2: { cellWidth: 40 },
            },
            styles: { fontSize: 11 },
            headStyles: { fontWeight: "normal" }, // Remove bold from head
          });

          addFooter(doc);
          doc.save(`Delivery_${shipmentCode}_${toscp}.pdf`);
        } else {
          console.error(`No shipment details found for scpto ${scpto}`);
        }
      });

      const extraResponse = await fetch(
        `${config.API_URL}/deliverychallan/all/${shipmentCode}/${selectedScpId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const extraData = await extraResponse.json();
      console.log("Extra API Response:", extraData); // Check the extra API response

      if (!extraData.success || !extraData.combinedDetails) {
        console.error(
          "Extra data is empty or not fetched correctly:",
          extraData
        );
        return;
      }

      const { shipmentDetails, productDetails } = extraData.combinedDetails;

      // Generate PDF for combined details
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      // PDF generation code for combined details
      const textColor = [0, 0, 0]; // Black (RGB)
      const headerTextColor = [255, 255, 255]; // White (RGB)
      const headerColor = [135, 206, 250]; // Light Blue (RGB)
      const rowColor = [255, 255, 255]; // White (RGB)

      const styles = {
        title: {
          fontSize: 24,
          color: textColor,
          fontStyle: "bold",
          margin: { top: 20 },
          align: "center",
        },
        detailsTable: {
          fontSize: 12,
          color: textColor,
          margin: { top: 10 },
          fillColor: rowColor,
        },
        tableHeader: {
          fontSize: 12,
          color: headerTextColor,
          fontStyle: "bold",
          fillColor: headerColor,
        },
        tableRow: {
          fontSize: 10,
          color: textColor,
          fillColor: rowColor,
        },
      };

      const imgData = ShubhamImage;
      doc.addImage(imgData, "PNG", 10, 10, 40, 20);

      const date = new Date();
      const formattedDate = `${String(date.getDate()).padStart(2,"0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
      const printedBy = `Printed By : ${UM_UserCode}`;
      const printedOn = `Printed On : ${formattedDate}`;
      const startX = doc.internal.pageSize.getWidth() - 50;
      let startY = 20;

      doc.setFontSize(8);
      doc.text(printedBy, startX, startY + 5, {
        textAlign: "right",
        fontWeight: "bold",
      });
      doc.text(printedOn, startX, startY, {
        textAlign: "right",
        fontWeight: "bold",
      });

      startY = startY + 20;
      doc.setTextColor(41, 128, 185);
      doc.setFontSize(21);
      doc.text("Delivery Challan", doc.internal.pageSize.width / 2, startY, {
        align: "center",
      });

      const FromlocationTable = [
        [
          {
            content: "Delivered By",
            colSpan: 2,
            styles: {
              halign: "center",
              fontSize: 12,
              fillColor: [41, 128, 185],
              textColor: [255, 255, 255],
            },
          },
        ],
        ["Address", `${shipmentDetails.Street1}, ${shipmentDetails.Street2}`],
        ["City", shipmentDetails.City],
        ["State", shipmentDetails.State],
        ["Country", shipmentDetails.Country],
        ["Email Address", shipmentDetails.Email],
        ["Contact No.", shipmentDetails.CNo],
      ];
      const columnWidth = (doc.internal.pageSize.width - 30) / 2; // Divide by 2 for two equal columns

      doc.autoTable({
        head: [],
        body: FromlocationTable,
        startY: 50,
        theme: "grid",
        styles: {
          ...styles.detailsTable,
          cellPadding: 2,
          valign: "middle",
          halign: "center",
          fontSize: 10,
        },
        columnStyles: {
          0: { cellWidth: columnWidth }, //cell padding to decrease the size between the two rows
          1: { cellWidth: columnWidth },
        },
      });

      const detailsTable = [
        [
          {
            content: "Shipment Information",
            colSpan: 2,
            styles: {
              halign: "center",
              fontSize: 12,
              fillColor: [41, 128, 185],
              textColor: [255, 255, 255],
            },
          },
        ],
        ["From Party", shipmentDetails.FromParty],
        ["Logistic Party Name", shipmentDetails.LGCM_Name],
        ["Vehicle Number", shipmentDetails.LGCVM_VehicleNumber],
      ];

      doc.autoTable({
        head: [],
        body: detailsTable,
        startY: doc.autoTable.previous.finalY + 5,
        theme: "grid",
        styles: {
          ...styles.detailsTable,
          cellPadding: 2,
          valign: "middle",
          halign: "center",
          fontSize: 10,
        },
        columnStyles: {
          0: { cellWidth: columnWidth }, //cell padding to decrease the size between the two rows
          1: { cellWidth: columnWidth },
        },
      });

      const batchDataHeaderText = "Product Details";
      const headers = [
        "Sr. No.",
        "SCP Name",
        "Product Code",
        "Product Name",
        "Quantity",
      ];

      let tableData = [];

      tableData.push([
        {
          content: batchDataHeaderText,
          colSpan: 5,
          styles: {
            halign: "center",
            fontSize: 12,
            textColor: [255, 255, 255],
            fillColor: [41, 128, 185],
          },
        },
      ]);

      // Add the header row with styles
      tableData.push(
        headers.map((header) => ({
          content: header,
          styles: {
            halign: "center",
            fillColor: [41, 128, 185],
            textColor: [255, 255, 255],
          },
        }))
      );

      // Add the product details rows
      tableData = tableData.concat(
        productDetails.map((row, index) => [
          { content: index + 1, styles: { halign: "center" } },
          row.SCPM_Name,
          row.dcm_productCode,
          row.dcm_productname,
          row.dcm_qty,
        ])
      );

      doc.autoTable({
        body: tableData,
        startY: doc.autoTable.previous.finalY + 5,
        theme: "grid",
        headStyles: {
          fillColor: [41, 128, 185],
          textColor: [255, 255, 255],
          lineWidth: 0.25,
          cellPadding: 2,
          valign: "middle",
          halign: "center",
          rowHeight: 8,
          border: {
            top: { style: "solid", width: 0.25, color: [0, 0, 0] },
          },
        },
        styles: {
          cellPadding: 2,
          valign: "middle",
          halign: "center",
        },
      });

      const signatureContent = [
        ["", "            ", "      ", "__________________________"],
        ["", "            ", "      ", "      Authorised Signature   "],
      ];

      // Calculate startX to align to the right side

      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 5,
        body: signatureContent,
        theme: "plain",
        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 40 },
          2: { cellWidth: 40 },
        },
        styles: { fontSize: 11 },
        headStyles: { fontWeight: "normal" }, // Remove bold from head

        startX: startX,
      });

      const previousTableFinalY = doc.autoTable.previous.finalY;
      const lineStartY = previousTableFinalY + 5;
      const lineEndY = lineStartY + 2;

      // Draw a blue dark line
      doc.setDrawColor(135, 206, 250); // Light blue color (RGB)
      doc.setLineWidth(0.5);
      doc.line(10, lineStartY, 200, lineStartY);

      const tableContent = [
        [
          { content: "Recieved By", styles: { fontStyle: "bold" } },
          "            ",
          { content: "Delivered By", styles: { fontStyle: "bold" } },
          "",
        ],
        ["Name", ":            ", "Name", ":"],
        ["Date", ":            ", "Date", ":"],
        ["Signature", ":            ", "Signature", ":"],
      ];

      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 5,

        body: tableContent,
        theme: "plain",
        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 60 },
          2: { cellWidth: 40 },
        },
        styles: { fontSize: 11 },
        headStyles: { fontWeight: "normal" }, // Remove bold from head
      });

      addFooter(doc);
      doc.save(`Delivery_${shipmentCode}_All.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  const addFooter = (doc) => {
    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      // Go to page i
      doc.setPage(i);

      // Set text alignment to left
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(
        "Developed by : Shubham Automation Pvt. Ltd.",
        10,
        doc.internal.pageSize.getHeight() - 10
      ); // at left side of the page

      // Add page number to the right side of the page
      doc.text(
        `Page ${i} of ${totalPages}`,
        doc.internal.pageSize.getWidth() - 20,
        doc.internal.pageSize.getHeight() - 10,
        { align: "right" }
      );
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  // ========================================================================================================
  //                                           Filteration
  // ========================================================================================================
  const [firstFilter, setFirstFilter] = useState(""); // First filter selection
  const [firstFilterSearch, setFirstFilterSearch] = useState(""); // First filter search input
  const [secondFilter, setSecondFilter] = useState(""); // Second filter selection
  const [secondFilterSearch, setSecondFilterSearch] = useState(""); // Second filter search input
  const [statusFilter, setStatusFilter] = useState(""); // Status filter selection

  const [firstFilterOptions, setFirstFilterOptions] = useState([
    { value: "SHPH_ShipmentCode", label: "Shipment Code", disabled: false },
    { value: "LGCM_Name", label: "Logistic Party", disabled: false },
    { value: "LGCVM_VehicleNumber", label: "Vehicle Number", disabled: false },
    { value: "RUTL_Name", label: "Route Name", disabled: false },
  ]);
  const [secondFilterOptions, setSecondFilterOptions] = useState([
    { value: "SHPH_ShipmentCode", label: "Shipment Code", disabled: false },
    { value: "LGCM_Name", label: "Logistic Party", disabled: false },
    { value: "LGCVM_VehicleNumber", label: "Vehicle Number", disabled: false },
    { value: "RUTL_Name", label: "Route Name", disabled: false },
  ]);

  const handleFirstFilterChange = (event) => {
    const value = event.target.value;
    setFirstFilter(value);
    setFirstFilterSearch("");
    const updatedSecondOptions = secondFilterOptions.map((option) => ({
      ...option,
      disabled: option.value === value,
    }));
    setSecondFilterOptions(updatedSecondOptions);
  };
  const handleSecondFilterChange = (event) => {
    const value = event.target.value;
    setSecondFilter(value);
    setSecondFilterSearch("");
    const updatedFirstOptions = firstFilterOptions.map((option) => ({
      ...option,
      disabled: option.value === value,
    }));
    setFirstFilterOptions(updatedFirstOptions);
  };
  useEffect(() => {
    // Whenever any of the filters change, reset to the first page
    setCurrentPage(1);
  }, [firstFilterSearch, secondFilterSearch, statusFilter]);

  const getStatusLabel = (status) => {
    switch (status) {
      case 1:
        return "Active";
      case 2:
        return "Inactive";
      case 3:
        return "Suspend";
      default:
        return "";
    }
  };

  //
  const filteredCombinedData = (Array.isArray(userData) ? userData : []).filter(
    (item) => {
      //const filteredCombinedData = userData.filter(item => {
      const firstFilterValue = item[firstFilter];
      const secondFilterValue = item[secondFilter];
      const statusValue = getStatusLabel(item.LCM_Status);
      const containsActive = /act(ive)?/i.test(firstFilterSearch);
      const containsInactive = /inact(ive)?/i.test(firstFilterSearch);// 
      const matchesFirstFilter =
        !firstFilter ||
        !firstFilterSearch ||
        (firstFilter === "LCM_Status" &&
          ((containsActive && firstFilterValue === 1) ||
            (containsInactive && firstFilterValue === 2))) ||
        (firstFilter !== "LCM_Status" &&
          String(firstFilterValue)
            .toLowerCase()
            .includes(firstFilterSearch.toLowerCase()));
      const containsActive2 = /act(ive)?/i.test(secondFilterSearch);
      const containsInactive2 = /inact(ive)?/i.test(secondFilterSearch);
      const matchesSecondFilter =
        !secondFilter ||
        !secondFilterSearch ||
        (secondFilter === "LCM_Status" &&
          ((containsActive2 && secondFilterValue === 1) ||
            (containsInactive2 && secondFilterValue === 2))) ||
        (secondFilter !== "LCM_Status" &&
          String(secondFilterValue)
            .toLowerCase()
            .includes(secondFilterSearch.toLowerCase()));
      const matchesStatusFilter = !statusFilter || statusValue === statusFilter;
      return matchesFirstFilter && matchesSecondFilter && matchesStatusFilter;
    }
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPosts = filteredCombinedData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastPost = currentPage * itemsPerPage;
  const indexOfFirstPost = indexOfLastPost - itemsPerPage;

  const handleStatusFilterChange = (event) => {
    const value = event.target.value;
    setStatusFilter(value);
  };

  // ========================================================================================================
  //                                           Filteration
  // ========================================================================================================

  return (
    <>
      <div className="main_container">
        <h4 className="formHeading">Completed Outward</h4>
        <div className="row">
          <div className="mb-3">
            <div className="filter-container">
              <div className="select-container_list">
                <CustomDropdown
                  options={firstFilterOptions}
                  value={firstFilter}
                  onChange={handleFirstFilterChange}
                  name="firstFilter"
                  placeholder="--Select--"
                  idKey="value"
                  displayKey="label"
                />
              </div>
              <input
                type="text"
                className="search-input"
                value={firstFilterSearch}
                onChange={(e) => setFirstFilterSearch(e.target.value)}
                placeholder={`Search`}
              />
              <div className="select-container_list">
                <CustomDropdown
                  options={secondFilterOptions}
                  value={secondFilter}
                  onChange={handleSecondFilterChange}
                  name="secondFilter"
                  placeholder="--Select--"
                  idKey="value"
                  displayKey="label"
                />
              </div>
              <input
                type="text"
                className="search-input"
                value={secondFilterSearch}
                onChange={(e) => setSecondFilterSearch(e.target.value)}
                placeholder="Search"
              />
            </div>
          </div>
        </div>

        <div className="ptable-wrapper">
          <table className="ptableClass">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th className="nav-tabs">Shipment Code</th>
                <th className="nav-tabs">Logistic Party</th>
                <th className="nav-tabs">Vehicle Number</th>
                <th className="nav-tabs">Route Name</th>
                <th className="nav-tabs">Action</th>
              </tr>
            </thead>
            <tbody>
              {currentPosts.length > 0 ? (
                currentPosts.map((shipment, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{shipment.SHPH_ShipmentCode}</td>
                    <td>{shipment.LGCM_Name}</td>
                    <td>{shipment.LGCVM_VehicleNumber}</td>
                    <td>{shipment.RUTL_Name}</td>
                    <td>
                      <img
                        src={Icon8}
                        onClick={() =>
                          handlePrintPDF(shipment.SHPH_ShipmentCode)
                        }
                        className="suspendicon"
                        alt="download"
                      ></img>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center" }}>
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
       
        <ul className="pagination">
          <li
            className={
              currentPage === 1 || filteredCombinedData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="page-linkd"
              onClick={() => paginate(1)}
              disabled={currentPage === 1 || filteredCombinedData.length === 0}
            >
              First
            </button>
          </li>
          <li
            className={
              currentPage === 1 || filteredCombinedData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="page-linkd"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1 || filteredCombinedData.length === 0}
            >
              Previous
            </button>
          </li>

          {filteredCombinedData.length > 0 &&
            Array.from(
              {
                length: Math.min(
                  10,
                  Math.ceil(filteredCombinedData.length / itemsPerPage)
                ),
              },
              (_, index) => {
                const totalPages = Math.ceil(
                  filteredCombinedData.length / itemsPerPage
                );
                const startPage = Math.max(
                  1,
                  Math.min(currentPage - 5, totalPages - 9)
                ); // Keeps a range of 10 pages centered around the current page
                const page = startPage + index;

                if (page > totalPages) return null; // Don't render pages exceeding the total count

                return (
                  <li
                    key={page}
                    className={
                      currentPage === page ? "page-item active" : "page-item"
                    }
                  >
                    <button
                      className="page-linkd"
                      onClick={() => paginate(page)}
                    >
                      {page}
                    </button>
                  </li>
                );
              }
            )}

          <li
            className={
              currentPage ===
                Math.ceil(filteredCombinedData.length / itemsPerPage) ||
              filteredCombinedData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="page-linkd"
              onClick={() => paginate(currentPage + 1)}
              disabled={
                currentPage ===
                  Math.ceil(filteredCombinedData.length / itemsPerPage) ||
                filteredCombinedData.length === 0
              }
            >
              Next
            </button>
          </li>

          <li
            className={
              currentPage ===
                Math.ceil(filteredCombinedData.length / itemsPerPage) ||
              filteredCombinedData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="page-linkd"
              onClick={() =>
                paginate(Math.ceil(filteredCombinedData.length / itemsPerPage))
              }
              disabled={
                currentPage ===
                  Math.ceil(filteredCombinedData.length / itemsPerPage) ||
                filteredCombinedData.length === 0
              }
            >
              Last
            </button>
          </li>
        </ul>
      </div>
      <Link to={`/ShipOutScanPendingList`} className="back_btn" type="button">
        BACK
      </Link>
    </>
  );
};

export default ShipOutScanedList;
